<template>
  <div class="orderGoods">
    <div class="total">共{{ cartInfo.length }}件商品</div>
    <div class="goodWrapper">
      <div
        class="item acea-row row-between-wrapper"
        v-for="cart in cartInfo"
        :key="cart.id"
      >
        <div class="pictrue" @click="$router.push({ path: '/detail/' + cart.product_id })">
          <img v-lazy="cart.productInfo.image" class="image" />
        </div>
        <div class="text">
          <div class="acea-row row-between-wrapper"  @click="$router.push({ path: '/detail/' + cart.product_id })">
            <div class="name line1"><span style="color:#fc4141;">{{cart.productInfo.goods_area_show}}</span>{{ cart.productInfo.store_name }}</div>
            <div class="num">x {{ cart.cart_num }}  </div>
          </div>
          <div class="attr line1" v-if="cart.productInfo.attrInfo"  @click="$router.push({ path: '/detail/' + cart.product_id })">
            {{ cart.productInfo.attrInfo.suk }}
          </div>
          <div class="money font-color-red"  style="position:relative;left:0px;bottom: -0.2rem;">
            ￥{{
            cart.truePrice
              /*cart.productInfo.attrInfo
                ? cart.productInfo.attrInfo.price
                : cart.productInfo.price*/
            }}
            <span v-if="cart.truePoint>0">+{{cart.truePoint}}购物券</span><span class="showpvclass" v-if="cart.show_truePv>0">({{cart.show_truePv}}pv)</span>

            <span style="position:absolute;right:0rem;" v-if="cart.delivery_status == 1 && cart.is_can_delivery==1" @click="
            $router.push({ path: '/order/logistics/' + cart.order_id+'/'+cart.unique })
          ">查看物流</span>
            <span style="position:absolute;right:0.2rem;" v-if="cart.delivery_status != 1 && cart.is_can_delivery==1">{{cart.delivery_status_name}}</span>


            <span style="position:absolute;"
                    class="item-btn logistics"
                    @click="toRefundSelection(cart)"
                    v-if="cart.area_return==1 && cart.is_return_id == 0"
            >申请售后</span>

            <span style="position:absolute;"
                    class="item-btn logistics"
                    @click="toRefundDetail(cart.is_return_id)"
                    v-if="cart.is_return_id > 0"
            >查看售后详情</span>


          </div>

          <div  v-if="cart.give_point_money>0" class="money font-color-red"  style="position:relative;left:0px;bottom: -0.2rem;">
            <span >赠送购物券:{{cart.give_point_money}}</span>
          </div>
          <div
            class="evaluate"
            v-if="evaluate === 3"
            @click="$router.push({ path: '/goods_evaluate/' + cart.unique })"
            style="top: 0.5rem;"
          >
            评价
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<style>
  .goodWrapper .item {
    height:2.4rem;
  }
</style>
<style scoped lang="scss">
  /*.goodWrapper .item {
    padding: 0.2rem 0.3rem 0.3rem 0.3rem;
  }*/
  .money-box {
    position: relative;
    left: 0px;
    margin-top: 0.07rem;
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
  }
  .item-btn {
    width: auto;
    height: 0.52rem;
    text-align: center;
    line-height: 0.52rem;
    border-radius: 0.5rem;
    font-size: 0.24rem;
    padding: 0 0.16rem;
    margin-left: 0.1rem;
    min-width: 1.32rem;
  }
  .item-btn.logistics,
  .item-btn.has-reply {
    border: 1px solid #ccc;
    color: #666;
    background-color: #fff;
  }
  .item-btn.after-sale {
    border: 1px solid #ec5d59;
    color: #ec5d59;
    background-color: #fff;
  }
  .item-btn.no-reply {
    border: 1px solid #ec5d59;
    color: #ec5d59;
    background-color: #fff;
  }
  .btn-group {
    margin-top: 0.3rem;
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: flex-end;
  }
</style>
<script>
export default {
  name: "OrderGoods",
  props: {
    evaluate: Number,
    cartInfo: {
      type: Array,
      default: () => []
    },
    // 总订单id
    topOrderId: {
      type: String,
      default: ""
    },
    showAfterSale: {
      type: Boolean,
      default: false
    }
  },
  data: function() {
    return {};
  },
  mounted: function() {},
  methods: {
    toRefundSelection(cart) {
      this.$router.push(
              "/user/refund_select?oid=" + this.topOrderId + "&unique=" + cart.unique
      );
    },
    toRefundDetail(refund_id) {
      this.$router.push("/user/refund_detail?id=" + refund_id);
    }
  }
};
</script>
